// @flow

// Libs
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

// Icons
import BarChart from 'fc-icons/src/BarChart'

// Constants
import {
  COMMENTS_ROUTE,
  RECOMMENDED_RATES_ROUTE,
} from 'hfty-comments-dom'
import {
  ATTR_COMMENT_ID,
  ATTR_RECOMMENDED_RATES,
  ATTR_JOB_ID,
} from 'hfty-datatable-comments/src/constants'

// Columns config
import COLUMNS from '../columnsConfig'

// Styles
import { grey } from 'hfty-styles/src/colors'

// Types
import { CommentRecord } from '../../types'

// Props type
type Props = {
  children?: any,
}

// Exports
export default function commentsTable (CommentsDataTable: Function): Function {
  return class CommentsTable extends Component {
    props: Props
    renderer: { [string]: Function }

    constructor (props: Props) {
      super(props)

      this.renderer = {
        [ATTR_RECOMMENDED_RATES]: this.renderRecommendedRatesIcon.bind(this),
      }
    }

    renderRecommendedRatesIcon (record: CommentRecord): ?React.Element<any> {
      return (
        <Link
          key={record[ATTR_COMMENT_ID]}
          to={`${COMMENTS_ROUTE}/${record[ATTR_JOB_ID]}${RECOMMENDED_RATES_ROUTE}/${record[ATTR_COMMENT_ID]}`}
        >
          <BarChart color={grey(0.8)} />
        </Link>
      )
    }

    render (): React.Element<any> {
      return (
        <CommentsDataTable
          columns={COLUMNS}
          renderer={this.renderer}
          defaultColumn={ATTR_COMMENT_ID}
          tools={this.props.children}
        />
      )
    }
  }
}
